/*
 * @Author: your name
 * @Date: 2020-06-11 16:24:48
 * @LastEditTime: 2020-06-23 10:43:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \client-v4\src\i18n\lang\it.js
 */
module.exports = {
    buyRegister: {
        mainName: 'Veuillez saisir le nom',//姓
        firstName: 'Veuillez saisir le prénom',//名
        email: 'Veuillez saisir une adresse email.',//邮箱
        confemail: 'Veuillez confirmer votre email.',//确认邮箱
        iphone: 'Veuillez saisir un numéro de téléphone.',//电话号码
        num: 'Veuillez saisir un numéro de fix.',//座机号码
        pwd: 'Veuillez saisir un numéro de téléphone.',//电话号码
        confpwd: 'Veuillez saisir un mot de passe.',//密码
        errorEmail: 'Veuillez saisir le même mot de passe.',//输入一样的密码
        errorPwd: 'Veuillez saisir le même mot de passe.',//输入一样的密码
        emailType: 'Veuillez saisir la même adresse mail',//输入一样的邮箱地址
        pwdType: 'Le forme de votre mot de passe est incorrect',//密码格式不正确
        webSite: 'Veuillez saisir votre site web',//网站地址
        confwebSite: 'Le forme de site web est incorrect',//网站地址不正确
        country: 'Veuillez selection votre pays',//国家
        intra: 'Veuillez saisir le numéro tva',//税号

        word1: 'Veuillez saisir un numéro de rue',//街道号码
        word2: 'Veuillez saisir une adresse',//地址
        word3: 'Veuillez saisir une ville.',//城市
        word4: 'Veuillez saisir un numéro de téléphone.',//电话号码
        word5: 'Veuillez saisir un nom de contact',//联系人姓
        word6: 'Veuillez saisir un code postal',//邮编
        word7: 'Veuillez saisir un numéro de rue',//请输入街道号码
        word8: 'Veuillez saisir une adresse.',//请输入地址
        word9: 'Veuillez saisir une ville.',//请输入城市
        word10: 'Veuillez saisir un numéro de téléphone.',//请输入联系电话
        word11: 'Veuillez saisir un nom de contact',//请输入联系人姓
        word12: 'Veuillez saisir un code postal',//请输入邮编
        word13: 'Veuillez saisir un nom',//请输入姓
        word14: 'Veuillez selectionner la langue par défaut',//请选择默认语言
        word15: 'Veuillez selectionner votre domaine d\'activité.',//请选择经营范围
        word16: 'Veuillez valider les conditions de politiques de confidentialité.',//请同意使用条款
        word17: 'english address must input eori.',//英国地址必须填写eori号码
    },
    sellRegister: {
        sell1: 'Veuillez saisir votre nom de société',//请输入企业名称
        sell2: 'Veuillez saisir un nom',//请输入商家姓
        sell3: 'Veuillez saisir un prénom',//请输入商家名
        sell4: 'Veuillez saisir le numéro tva',//请输入税号
        sell5: 'Veuillez saisir le nom de boutique',//请输入店铺名称
        sell6: 'Votre adresse mail est déja inscrit',//您的邮箱地址已注册
        sell7: 'Veuillez saisir un numéro de rue',//请输入街道号码
        sell8: 'Veuillez saisir une ville',//请输入商家城市
        sell9: 'Veuillez saisir une ville',//请输入商家城市
        sell10: 'Veuillez saisir une adresse',//请输入地址
        sell11: 'Veuillez saisir un code postal',//请输入邮编
        sell12: 'Veuillez télécharger votre kbis',//请输入税号
        sell13: 'Entrez le numéro de la banque commerciale',//请输入商家银行号
        sell14: 'Veuillez indiquer les coordonnées de la banque commerciale',//请输入商家银行号
        sell15: 'Veuillez télécharger votre piéce d\'indentité',//请上传商家身份证件
        sell16: 'Veuillez saisir votre(vos) marque(s)',//请添加商家品牌
        sell17: 'Veuillez saisir vos catégories',//请选择商家产品目录
        sell18: 'Veuillez saisir le montant minimum de commande',//请填写最低订单要求
        sell19: 'Veuillez saisir un chiffre',//请输入有效数字
        sell20: 'Veuillez selection vos domaine d\'activité'//请选择商家营业范围
    },
    account: {
        word1: "déconnecter",//登出
        word2: "L'adrresse mail ne doit pas être vide", //email地址不能为空
        word3: "Les deux boîtes aux lettres ne coïncident pas",//两个邮箱地址不一致
        word4: "Je souscris à la newsletter d'efashion paris",//是否订阅邮件
        word5: "Je reçois des notifications sur l'app ",//是否接收手机应用的同志
        word6: "Je reçois des sms",//是否接收订单更新的短信通知
    },
    seller_marques: {
        word1: "le vendeur a bien été ajouté aux favoris.",//添加收藏成功 商家
        word2: "le vendeur a bien été retiré dans favoris.",//取消收藏成功 商家
        word3: "Merci de se connecter pour effectuer cette action.",//请先登录 再进行这个操作
    },
    product_detail: {
        word1: "le produit a été ajouté au panier!",//产品已经添加到购物车
        word2: "La quantité de min de commande est ",//最低订购数量为
        word3: "Couleurs",//颜色
        word4: "Paquets",//包
        word5: "Qté",//数量
        word6: "Total",//总数
        word7: "Quantité ou montant acheté incorrect",//购买数量或者金额有误
    },
    goods_list: {
        couleurs: 'à la couleur',
        melangees: 'Couleurs mélangées',
        tailles: 'Tailles aux choix',
    },
    favor_articles: {
        word1: "Ajouter aux favoris avec succès!",//添加收藏成功
        word2: "Retirer aux favoris avec succès!",//收藏产品成功
        word3: "Échec de l’opération,veuillez reessayer.",//收藏操作失败
    },
    common: {
        yes: 'Oui',//是
        no: 'Non'//否
    },
    moncompte_articles: {
        word1: 'Un ou plusieurs articles ont des défaut ',
        word2: 'Articles manquants',
        word3: 'J’ai reçu un ou plusieurs articles qui ne correspondent pas à ma commande',
        word4: `Bonjour, j'ai "nombre d'articles" endommagés dans ma commande dont vous trouverez ci-joint les photos (télécharger les photos). Merci de faire un retour par rapport à ma demande.`,
        word5: 'Bonjour, je viens de recevoir ma commande et il me manque les produits suivants : "compléter par l\'acheteur". Merci d\'en informer le fournisseur et de me faire un retour.',
        word6: 'Bonjour, je viens de recevoir ma commande et "détailler le probleme précisément, mauvaise référence, couleur, taille". Merci d\'en informer le fournisseur et de me faire un retour.',
        word7: 'autre',
    },
    topMenuDesc: {
        'Accessoires': 'Accessoires',
        'Marques': 'Marques',
        'Nouveautés': 'Nouveautés',
        'Outlet': 'Outlet',
        'Vêtements': 'Vêtements',
        'decouvrir': 'decouvrir',
        "AJOURD HUI": "Aujourd’hui",
        'CETTE SEMAINE': 'CETTE SEMAINE',
        'NOUVEAUX VENDEURS': 'NOUVEAUX VENDEURS',
        'Nouveautés Vêtements': 'Nouveautés Vêtements',
        'Nouveautés Accessoires': 'Nouveautés Accessoires',
        'Tendances': 'Tendances',
    },
    topMenuOutlet: {
        word1: 'ACHETER PAR PRIX',
        word2: "jusqu'à 5€",
        word3: "5€ jusqu'à 10€",
        word4: "10€ jusqu'à 15€",
        word5: 'ACHETER PAR REMISE',
        word6: "jusqu'à-30%",
        word7: 'de-30%à-50%',
        word8: 'Plus de-50%',
        word9: 'Les codes promos',
        word10: "Les remises",
        word11: "TOUTES LES PROMOTIONS",
        word12: "Promos Hauts",
        word13: "Promos Robes & Combinaisons",
        word14: "Promos Chaussures",
        word15: "Promos Maroquinerie",
        word16: "Promos Grandes tailles",
        word17: "MOINS DE",
        word18: "5€",
        word19: "MOINS DE 5€",
    },
    topMenuNoLogin: {
        'preview catalog': 'Avant-première catalogue',
    },
    chooseCarte: {
        word1: 'eori can not empty',
        word2: 'english need eori,please add eori at address modify',
    },
    homeLogin: {
        word1: 'copier',
    }
}
